<template>
  <div>
    <b-loading
      class="xb-loading"
      :is-full-page="false"
      :active.sync="loading"
      :can-cancel="true"
      style="z-index: 999;"
    />
    <!-- Notification when mount failed -->
    <b-notification
      class="xb-notification xb-notification-icon"
      has-icon
      :closable="false"
      :type="'is-danger'"
      :active.sync="mountFailed"
      >{{ notificationMessage }}</b-notification
    >
    <div :id="commonVariable.container"></div>
  </div>
</template>

<script>
import { loadMicroApp } from "qiankun";
import fetchPermissionMixin from "../mixins/fetchPermissionMixin.js";

import Mgr from "./../services/securityService.js";
import vuexSignoutUtility from "./vuexSignoutUtility";

const mapState = window.Vuex.mapState;

export default {
  mixins: [fetchPermissionMixin],
  data() {
    return {
      loading: true,
      microApp: null,
      notificationMessage: "",
      mountFailed: null
      // MicroApp (Common Functions) variable
    };
  },
  props: {
    commonVariable: {
      type: Object,
      required: true
    }
  },
  computed: mapState({
    accessToken: state => state.auth.accessToken
  }),
  methods: {
    constructMicroAppVuexUtils() {
      this.$store.registerModule("microAppsUtility", vuexSignoutUtility);

      const initializedMgr = new Mgr(
        this.$store.state.config.configurationData.common_module
      );
      this.$store.commit("microAppsUtility/setUserManager", initializedMgr);
    },
    loadMicroAppAfterFetch() {
      if (!this.microApp) {
        const { apiBaseUrl } = this.$store.state.config.configurationData;
        // const apiBaseUrl = "http://localhost:8099";

        this.constructMicroAppVuexUtils();

        this.microApp = loadMicroApp({
          name: this.commonVariable.name,
          entry: `${apiBaseUrl}${this.commonVariable.entry}`,
          container: `#${this.commonVariable.container}`,
          activeRule: location =>
            location.pathname.includes(this.commonVariable.pathname),
          props: { vuex: this.$store }
        });
        this.microApp.mountPromise
          .then(() => {
            this.loading = false;
            this.mountFailed = false;
          })
          // If failed to mount
          .catch(e => {
            this.loading = false;
            this.mountFailed = true;
            this.notificationMessage = e.message;
          });
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("rules/destroyRules");
    this.$store.unregisterModule("microAppsUtility");
  },
  destroyed() {
    this.microApp.mountPromise.then(this.microApp.unmount());
  }
};
</script>
